/*!
 * AudoChat - Protected Route Component
 */

import { Route, Redirect } from "react-router-dom";
import auth from "utils/auth";

function ProtectedRoute({ component: Component, ...rest }) {
  const isAuthenticated = auth.isAuthenticated();
  const canAccess = rest.permission ? auth.hasPermission(rest.permission) : true;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return <Redirect to="/authentication/sign-in" />;
        }

        if (!canAccess) {
          return <Redirect to="/dashboard" />;
        }

        return <Component {...props} />;
      }}
    />
  );
}

export default ProtectedRoute;

